import jQuery from 'jquery';

import './settings.css';

import addonBox from '../screen-dashboard/addon-box';

jQuery( () => {
	addonBox();
} );
